import api from './api'

/**
 * Initiate a GIS raster upload — server returns presigned URLs (single or multipart).
 * @param {Object} payload — { filename, raster_type, layer_name, description?, folder_id?, size, mime }
 * @returns {Promise<{ raster_id: number, upload_id: string, s3_key: string, mode: 'single'|'multipart', put_url?: string, multipart_upload_id?: string, chunk_size?: number, total_chunks?: number, presigned_part_urls?: Array<{part_number: number, url: string}>, expires_in: number }>}
 */
export async function initiateGisRasterUpload(payload) {
  const res = await api.post('/gis/raster/initiate', payload)
  return res.data
}

/**
 * Finalize a GIS raster upload — completes multipart on S3 (if applicable) and kicks Django.
 * @param {number|string} rasterId
 * @param {{mode: 'single'} | {mode: 'multipart', parts: Array<{part_number: number, etag: string}>}} finalizeBody
 * @returns {Promise<{ status: string, raster_id: number, upload_id: string }>}
 */
export async function finalizeGisRasterUpload(rasterId, finalizeBody) {
  const res = await api.post(`/gis/raster/finalize/${rasterId}`, finalizeBody)
  return res.data
}

/**
 * Abort a GIS raster upload — releases S3 multipart and deletes the row.
 * @param {number|string} rasterId
 * @returns {Promise<{ success: boolean }>}
 */
export async function abortGisRasterUpload(rasterId) {
  const res = await api.post(`/gis/raster/abort/${rasterId}`)
  return res.data
}

/**
 * List GIS rasters for the JWT user's resort. Server scopes by user.resort_id.
 * @returns {Promise<{ rasters: Array }>}
 */
export async function listGisRasters() {
  const res = await api.get('/gis/raster')
  return res.data
}

/**
 * Delete a GIS raster (cascade S3 + DB). Server checks resort scope.
 * @param {number|string} rasterId
 * @returns {Promise<{ success: boolean }>}
 */
export async function deleteGisRaster(rasterId) {
  const res = await api.delete(`/gis/raster/${rasterId}`)
  return res.data
}

/** Initiate a tiled-ortho (mosaic) upload — server returns a staging prefix + N presigned PUTs. */
export async function initiateGisMosaicUpload(payload) {
  const res = await api.post('/gis/raster/mosaic/initiate', payload)
  return res.data
}

/** Finalize a mosaic upload — Express flips the row to processing and kicks Django ingest. */
export async function finalizeGisMosaicUpload(rasterId) {
  const res = await api.post(`/gis/raster/mosaic/finalize/${rasterId}`)
  return res.data
}

/** Abort a mosaic upload — deletes the staging tiles and the row. */
export async function abortGisMosaicUpload(rasterId) {
  const res = await api.post(`/gis/raster/mosaic/abort/${rasterId}`)
  return res.data
}
